import { useMatch } from 'react-router-dom'

//현재 route 확인용
const useMatchHook = () => {
  const matchLogin = useMatch('/')
  const matchReset = useMatch('/reset')
  const matchHome = useMatch('/home')
  const matchLocation = useMatch('/location')
  const matchLocationDetail = useMatch('/location/detail/:idx')
  const matchExplorer = useMatch('/explorer')
  const matchSetting = useMatch('/setting')
  const matchCamera = useMatch('/camera')
  const matchExplorer_delete = useMatch('/explorer/delete')
  const matchExplorer_detail = useMatch('/explorer/detail/:fileType')
  const matchExplorer_detail_filetype = useMatch('/explorer/detail/:fileType')?.params.fileType

  return {
    m_login: matchLogin,
    m_reset: matchReset,
    m_home: matchHome,
    m_location: matchLocation,
    m_location_detail: matchLocationDetail,
    m_explorer: matchExplorer,
    m_setting: matchSetting,
    m_camera: matchCamera,
    m_explorer_detail: matchExplorer_detail,
    m_explorer_detail_param: matchExplorer_detail_filetype,
    m_explorer_delete: matchExplorer_delete,
  }
}
export default useMatchHook
